import {mergeMap} from 'rxjs/operators';
import {Component, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {CommonService} from '../../services/';
import {Observable, of} from 'rxjs';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './app-autocomplete.component.html',
  styleUrls: ['./app-autocomplete.component.scss']
})
export class AppAutocompleteComponent implements OnChanges {

  @Input() type: string;
  @Input() value: string;
  @Input() required?: boolean;
  @Input() results?: any[] = null;
  @Input() typeaheadOptionsLimit = 7;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  asyncSelected: string;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean;
  dataSource: Observable<any>;

  ngOnChanges(event) {
    if (event['value'] && !event['value']['currentValue']) {
      this.asyncSelected = '';
      this.notify.emit();
    } else if (event['value'] && event['value']['currentValue']) {
      this.asyncSelected = event['value']['currentValue'];
      if (this.type === 'industry') {
        this.asyncSelected = event['value']['currentValue']['name_en']
      }
    }
  }

  constructor(private commonService: CommonService) {
    this.dataSource = Observable.create((observer: any) => {
      // Runs on every search
      observer.next(this.asyncSelected);
    }).pipe(mergeMap((token: string) => this.getStatesAsObservable(token)));
  }

  getStatesAsObservable(token: string): Observable<any> {
    if (this.results && this.results.length > 0) {
      console.log('TOKEN', token);
      return of(this.results.filter(r => r.name.toLowerCase().indexOf(token.toLowerCase()) > -1));
    } else {
      switch (this.type) {
        case 'universities':
          return this.commonService.getUniversityByName(token).pipe(mergeMap(u => {
            console.log(u);
            return of(u['universities'])
          }));
        case 'cities':
          return this.commonService.getCitiesByName(token).pipe(mergeMap(u => {
            return of(u['cities'])
          }));
        case 'languages':
          return this.commonService.getLanguagesByName(token).pipe(mergeMap(u => {
            return of(u['languages'])
          }));
        case 'skills':
          return this.commonService.getSkillsByName(token).pipe(mergeMap(u => {
            return of(u['skills'])
          }));
        case 'industry':
          return this.commonService.getIndustriesByName(token).pipe(mergeMap(u => {
            return of(u['industries'])
          }));
        case 'study_tags':
          return this.commonService.getStudyTags(token).pipe(mergeMap(u => {
            return of(u['list'].map(item => {return {id: item.id, name: item.name_en }}))
          }));

        case 'geolocations':
          return this.commonService.getGeolocations(token).pipe(mergeMap(u => {
            return of(u['list'].map(item => {return {id: item.id, name: item.formattedNameEn }}))
          }));
      }
    }
  }

  changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  changeTypeaheadNoResults(e: boolean): void {
    this.typeaheadNoResults = e;
  }


  typeaheadOnSelect(e: TypeaheadMatch): void {
    // if (this.type === 'skills') {
    //   this.notify.emit(e.item);
    // } else 
    if (this.type === 'industry') {
      e.item.type = 'industry';
      this.notify.emit(e.item);
    } else {
      if(e.item && e.item.id){
        this.notify.emit({'value': e.value, 'id': e.item.id});
      } else {
        this.notify.emit(e.value);
      }
    }
  }


  onChange(event) {
    // console.log('onChange', event);
    if (!event) {
      this.notify.emit();
    }
  }


}
